// src/components/ReportPDF.jsx

import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

// Exemplo simples de estilos
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    fontFamily: "Helvetica",
    flexDirection: "column",
  },
  title: {
    fontSize: 14,
    marginBottom: 10,
    fontWeight: "bold",
  },
  section: {
    marginBottom: 10,
  },
  tableHeader: {
    flexDirection: "row",
    borderBottom: 1,
    marginBottom: 5,
    paddingBottom: 5,
    fontWeight: "bold",
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: 1,
    paddingVertical: 3,
  },
  columnHeader: {
    width: "20%",
  },
  columnText: {
    width: "20%",
  },
  totalSection: {
    marginTop: 10,
    textAlign: "right",
  },
  logo: {
    width: 80,
    height: 80,
  },
});

// Exemplo de formatação para BRL
const formatCurrency = (value) => {
  if (!value) value = 0;
  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};

const ReportPDF = ({ payment, professionals }) => {
  console.log("Profissionais: 2", professionals);
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Logo da empresa */}
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Image
            src={require("../assets/img/achemed-simbolo-azul.png")}
            style={styles.logo}
          />

          {/* Título e informações gerais */}
          <View style={styles.section}>
            <Text style={styles.title}>
              Relatório de Distribuição de Receita
            </Text>
            <View style={styles.section}>
              <Text>ID do Repasse: {payment.id}</Text>
              <Text>
                Período: {payment.start_date} - {payment.end_date}
              </Text>
              <Text>Mês de Repasse: {payment.transfer_month}</Text>
            </View>
          </View>
        </View>

        {/* Cabeçalho da Tabela */}
        <View style={styles.tableHeader}>
          <Text style={styles.columnHeader}>Nome</Text>
          <Text style={styles.columnHeader}>Paciente</Text>
          <Text style={styles.columnHeader}>Valor do Proc.</Text>
          <Text style={styles.columnHeader}>Valor Pago</Text>
          <Text style={styles.columnHeader}>Procedimento</Text>
        </View>

        {/* Linhas da Tabela */}
        {professionals.map((prof, index) => (
          <View style={styles.tableRow} key={index}>
            <Text style={styles.columnText}>
              {prof.executing_company || "N/A"}
            </Text>
            <Text style={styles.columnText}>{prof.customer_name || "N/A"}</Text>
            <Text style={styles.columnText}>
              {formatCurrency(prof.procedure_price)}
            </Text>
            <Text style={styles.columnText}>
              {formatCurrency(prof.procedure_value)}
            </Text>
            <Text style={styles.columnText}>
              {prof.procedure_name || "N/A"}
            </Text>
          </View>
        ))}

        {/* Rodapé com total (por exemplo) */}
        <View style={styles.totalSection}>
          <Text>Total de Empresas: {professionals.length}</Text>
          <Text>Valor Total Pago: {formatCurrency(payment.total_amount)}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default ReportPDF;
